import React from 'react'

import { defaultAuthenticationValue } from './authentication.default'

export const AuthenticationContext = React.createContext(defaultAuthenticationValue)


// createBrowserRouter([ 
//         {
//             path: "/",
//             element: <App />,
//             errorElement: <PageNotFound />,
//             children: [
//                 {
//                     path: "/",
//                     element: <Login />
//                 },
//                 {
//                     path: "/logout",
//                     element: <Logout />
//                 },
//                 {
//                     path: "jobs",
//                     element: <JobList />
//                 },
//                 {
//                     path: "jobs/:jobId",
//                     element: <JobDetail />
//                 },
//                 {
//                     path:"schedule",
//                     element: <Schedule />
//                 },
//                 {
//                     path: "schedule/:startDateString",
//                     element: <Schedule />
//                 },
//                 {
//                     path: "schedule/jobDay/:jobDayId",
//                     element: <JobDayDetail />
//                 },
//                 {
//                     path: "crew",
//                     element: <CrewList />
//                 },
//                 {
//                     path: "crew/:crewMemberId",
//                     element: <CrewDetail />
//                 },
//                 {
//                     path: "inventory",
//                     element: <Inventory />
//                 },
//                 {
//                     path: "inventory/equipment",
//                     element: <EquipmentList />
//                 },
//                 {
//                     path: "inventory/equipment/:equipmentId",
//                     element: <EquipmentDetail />
//                 },
//                 {
//                     path: "inventory/equipment/requests",
//                     element: <EquipmentRequestList />
//                 },
//                 {
//                     path: "inventory/equipment/requests/:requestId",
//                     element: <EquipmentRequestDetail />
//                 },
//                 {
//                     path: "inventory/purchase-orders",
//                     element: <PurchaseOrderList />
//                 },
//                 {
//                     path: "inventory/purchase-orders/:orderId",
//                     element: <PurchaseOrderDetail />
//                 }
//             ]
//         }
//     ])